<script>
import { mapGetters } from 'vuex';
import { hasPressedCommand } from 'shared/helpers/KeyboardHelpers';
import GalleryView from '../components/GalleryView.vue';
import { timeStampAppendedURL } from 'dashboard/helper/URLHelper';
import { emitter } from 'shared/helpers/mitt';
import MyButton from 'dashboard/components-next/button/Button.vue';
import { useAlert, useTrack } from 'dashboard/composables';
import {
  getUserPermissions,
  hasPermissions,
} from 'dashboard/helper/permissionsHelper.js';

export default {
  components: {
    MyButton,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      isImageError: false,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      currentAccountId: 'getCurrentAccountId',
    }),
    isDisabledCreate() {
      return this.message.content_attributes?.order_info;
    },
    userPermissions() {
      return getUserPermissions(this.currentUser, this.currentAccountId);
    },
    showDelete() {
      return (
        !hasPermissions(['encrypt_message'], this.userPermissions) &&
        !this.isDisabledCreate
      );
    },
    messageContent() {
      return !hasPermissions(['encrypt_message'], this.userPermissions)
        ? this.message.content_attributes?.gift_card_info?.cdkey
        : this.message.content;
    },
  },
  methods: {
    onInitOrder() {
      emitter.emit('createGiftCardOrder', this.message);
    },
    notCard() {
      try {
        this.$store.dispatch('giftCards/notCard', { id: this.message.id });
        useAlert('Success');
      } catch (error) {
        useAlert(error);
      } finally {
      }
    },
  },
};
</script>

<template>
  <div class="flex-row">
    <p class="text-blue-600">{{ messageContent }}</p>
    <div class="flex flex-row mt-4">
      <MyButton sm :disabled="isDisabledCreate" @click="onInitOrder">
        Create Order
      </MyButton>
      <MyButton v-if="showDelete" sm ruby class="mx-3" @click="notCard">
        Not Card
      </MyButton>
    </div>
  </div>
</template>
